import { render, staticRenderFns } from "./Lampblack.vue?vue&type=template&id=234008a0&scoped=true&"
import script from "./Lampblack.vue?vue&type=script&lang=js&"
export * from "./Lampblack.vue?vue&type=script&lang=js&"
import style0 from "./Lampblack.vue?vue&type=style&index=0&id=234008a0&scoped=true&lang=scss&"
import style1 from "./Lampblack.vue?vue&type=style&index=1&id=234008a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234008a0",
  null
  
)

export default component.exports